import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { I18n } from "aws-amplify";
import { Row, Col } from "antd";
import LoggedPage from "../../../../../components/page-templates/fillForm-logged";
import { ContentPage } from "../../../RegistrationFlow/Full/DiversityAndInclusion/content-page";
import { Menu } from "../../components/Menu";
import { ModalBp } from "../../../../components/UI/ModalBp/ModalBp";
import { PARTNER_API } from "../../../../../actions/partner/actions";

//import * as S from './styles';

export const EditDiversityAndInclusion = () => {
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();

  const handleOkInfos = (status) => {
    if (status) {
      setVisible(true);
    }
  };

  const handleOkUpdate = () => {
    setVisible(false);
    dispatch(PARTNER_API.get());
  };

  return (
    <>
      <LoggedPage>
        <div className="hero-body">
          <div className="container">
            <Row style={{ marginTop: 58 }}>
              <Col xs={6}>
                <Menu />
              </Col>
              <Col xs={18}>
                <ContentPage
                  contextPage="edit"
                  onChangeInfo={(info) => console.log("change", info)}
                  sendOk={(status) => handleOkInfos(status)}
                />
              </Col>
            </Row>
          </div>
        </div>
      </LoggedPage>

      <ModalBp
        visible={visible}
        bodyText={I18n.get("Saved information.")}
        subBodyText={I18n.get("Your information has been successfully saved.")}
        okText={I18n.get("OK")}
        // cancelText={I18n.get("Cancelar")}
        handleClickOk={() => handleOkUpdate()}
        onCancel={() => setVisible(false)}
        // typeModal="isConfirm"
        // isDanger={true}
      />
    </>
  );
};
